import axios from "axios";

export const fetchUsers = async(settings) =>{
    const { url,token} = settings; 
    const { origin } = new URL(url);
    
    try {
      const res=  await axios.get(`${origin}/users`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      return res.data.data;

    } catch (e) {
      console.error('Error fetching users:', e);
    }
};


export const submitUserInfo = async(user,settings) =>{

    const { url,token} = settings; 
    const { origin } = new URL(url);

    try {
      const res = await axios.post(`${origin}/users`,user, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return res;

    } catch (e) {
      return e.response.data;
    }
};